import React from "react";

const SwitchButton = ({
    firstButton,
    secondButton,
    isActive,
    setIsActive,
    firstIcon,
    secondIcon,
    disabled = false,
    greenTheme,
    entity = "",
    small = false,
}) => {
    return (
        <>
            <div className="flex items-center">
                <div
                    className={`upload-btn-area ${disabled ? "disabled" : ""}`}
                    id={`${firstButton}-${entity}-switch-container`}
                >
                    <input
                        type="radio"
                        className="uploading-items-radio"
                        name={`${firstButton}-${secondButton}-${entity}-group`}
                        id={`${firstButton}-${entity}-switch`}
                        checked={isActive}
                        onChange={() => setIsActive(true)}
                        disabled={disabled}
                    />
                    <label
                        className={`upload-box ${
                            small ? "text-xxs upload-box-small" : ""
                        } ${greenTheme ? "green-box" : ""}`}
                        htmlFor={`${firstButton}-${entity}-switch`}
                    >
                        {firstIcon && <i className={`fas fa-${firstIcon}`} />}
                        <span className="upload-box-text">{firstButton}</span>
                    </label>
                </div>
                <div
                    className={`upload-btn-area ${disabled ? "disabled" : ""}`}
                    id={`${secondButton}-${entity}-switch-container`}
                >
                    <input
                        type="radio"
                        className="uploading-items-radio"
                        name={`${firstButton}-${secondButton}-${entity}-group`}
                        id={`${secondButton}-${entity}-switch`}
                        checked={!isActive}
                        onChange={() => setIsActive(false)}
                        disabled={disabled}
                    />
                    <label
                        className={`upload-box ${
                            small ? "text-xxs upload-box-small" : ""
                        } ${greenTheme ? "green-box" : ""}`}
                        htmlFor={`${secondButton}-${entity}-switch`}
                    >
                        {secondIcon && <i className={`fas fa-${secondIcon}`} />}
                        <span className="upload-box-text">{secondButton}</span>
                    </label>
                </div>
            </div>
        </>
    );
};

export default SwitchButton;
